import {inject} from '@angular/core'
import {ResolveFn} from '@angular/router'

import {filter} from "rxjs";
import {UserDomain} from "../../shared/domain/user.domain";
import {User} from "../../shared/models/user";

export function globalResolver(): ResolveFn<User> {
  return () => {
    const userDomain: UserDomain = inject(UserDomain)
    if(!userDomain.connectedUser()) {
      userDomain.loadConnectedUser().subscribe()
    }
    return userDomain.connectedUser$.pipe(filter(user => !!user))
  }
}

